export default __webpack_public_path__ + "static/media/AM2_Pattern_A.add48b7a.png";